import { render, staticRenderFns } from "./teamMember.vue?vue&type=template&id=c06beada&scoped=true&"
import script from "./teamMember.vue?vue&type=script&lang=js&"
export * from "./teamMember.vue?vue&type=script&lang=js&"
import style0 from "./teamMember.vue?vue&type=style&index=0&id=c06beada&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c06beada",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c06beada')) {
      api.createRecord('c06beada', component.options)
    } else {
      api.reload('c06beada', component.options)
    }
    module.hot.accept("./teamMember.vue?vue&type=template&id=c06beada&scoped=true&", function () {
      api.rerender('c06beada', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2OfT77Clry80d/JS/teamMember.vue"
export default component.exports